/**
 * @generated SignedSource<<8cfb58b1853596a5f75ad09422c025a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedControlledHeadingWrapper_itemSearch$data = {
  readonly meta: {
    readonly subHeader: string | null;
  } | null;
  readonly " $fragmentType": "SbSharedControlledHeadingWrapper_itemSearch";
};
export type SbSharedControlledHeadingWrapper_itemSearch$key = {
  readonly " $data"?: SbSharedControlledHeadingWrapper_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedControlledHeadingWrapper_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedControlledHeadingWrapper_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subHeader",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "cb8487198d9bdb02a1467175dfae95fc";

export default node;
